import {OrganizationApiDto} from "../../api/model/rest";
import {none, option, Option} from "ts-option";

/**
 * Organization information model.
 */
export default class Organization {
	constructor(public readonly id: string,
		public readonly name: string,
		public readonly brandId: Option<string>,
		public readonly brandName: Option<string>) {}

	static fromJson(json: OrganizationApiDto): Organization {
		const brandId = json.defaultBrand ? option(json.defaultBrand.id) : none;
		const brandName = json.defaultBrand ? option(json.defaultBrand.name) : none;
		return new Organization(json.id, json.name, brandId, brandName);
	}
}
